export const median = (a: number[]): number => {
  const s = [...a].sort((x, y) => x - y);
  const h = s.length >> 1;
  return s.length % 2 ? s[h] : (s[h - 1] + s[h]) / 2;
};

export const mean = (a: number[]): number =>
  a.reduce((s, x) => s + x, 0) / a.length;

export const std = (a: number[]): number => {
  const mu = mean(a);
  return Math.sqrt(mean(a.map((x) => (x - mu) * (x - mu))));
};

/** Clamp with [0,100] default bounds. */
export const clamp = (v: number, a = 0, b = 100): number =>
  Math.max(a, Math.min(b, v));

/** Clamp requiring explicit bounds. */
export const clampNum = (v: number, a: number, b: number): number =>
  Math.max(a, Math.min(b, v));

export const percentile = (arr: number[], p: number): number => {
  const s = [...arr].sort((a, b) => a - b);
  const i = Math.min(
    s.length - 1,
    Math.max(0, Math.round((p / 100) * (s.length - 1))),
  );
  return s[i];
};

/** Abramowitz-Stegun error-function approximation. */
export const erf = (x: number): number => {
  const t = 1 / (1 + 0.3275911 * Math.abs(x));
  const y =
    1 -
    ((((1.061405429 * t - 1.453152027) * t + 1.421413741) * t - 0.284496736) *
      t +
      0.254829592) *
      t *
      Math.exp(-x * x);
  return x >= 0 ? y : -y;
};
